<template>
  <div>
    <applications-carrier-header></applications-carrier-header>
    <applications-carrier-steps></applications-carrier-steps>
  </div>
</template>

<script>
import ApplicationsCarrierHeader from './header';
import ApplicationsCarrierSteps from './steps/';

export default {
  name: 'ApplicationsCarrier',
  components: {
    ApplicationsCarrierHeader,
    ApplicationsCarrierSteps,
  },
};
</script>
